import {ref, computed} from 'vue';
import { CrmInstallData } from '../CrmInstallData.js';


export function useBaseStep(props, emit, validateForm) {
	const validateEnabled = ref(false);
	const progress = ref(false);
	const errorMessage = ref("");
	//const emptyErrorResource = msg("err.empty");
	
	const isError = computed(() => {
		return Boolean(errorMessage.value);
	});
	
	const upgrade = computed(() => {
		return props.form && props.form.selection==='upgrade';
	});

	function postFormData(url: string, formData: CrmInstallData): Promise<boolean> {
		progress.value=true;
		errorMessage.value="";
		//console.log("Post data to:"+url);
		//console.log("Data:"+JSON.stringify(formData));
		return fetch(url,{ 
			method: "POST",
			body: JSON.stringify(formData),
			headers: {
				'Content-type': 'application/json; charset=UTF-8'
			}
		})
		.then(response => response.json())
		.then(data => {
			//console.log("get:"+JSON.stringify(data));
			if (data.ok) {
				if (data.reload) {
					emit("reload");
				}
				return true;
			}
			else {
				//parse error
				errorMessage.value=data.problems[0].message;
				return false;
			}
		})
		.catch((error) => {
			//console.log("Error sending form:"+error.message);
			errorMessage.value=error.message;
			return false;
		})
		.finally(() => {
			progress.value=false;
		});
	}
	
	function sendForm(formData: CrmInstallData, nextStep?: string): void {
		validateEnabled.value=true;
		errorMessage.value="";
		if (validateForm()) {
			validateEnabled.value=false;
			postFormData(getUrl(),formData)
				.then((result)=>{
					if (result && nextStep) {
						console.log("form sent, go to step:"+nextStep);
						emit("nextStep",nextStep);
					}
				});
		}
	}
	
	function submitOnEnter(e, callback): void {
		if (e.keyCode == 13) {//enter
			callback();
			e.preventDefault();
		}
	}
	
	function getUrl(): string {
		return props.restApi+props.endPoint;
	}
	
	function nextStep(nextStep: string): void {
		console.log("emiting step:"+nextStep);
		emit("nextStep",nextStep);
	}
	
	function errEmptyStringClass(value: string): string {
		return (!validateEnabled.value || Boolean(value))?"":"error";
	}
	
	function errEmptyNumberClass(value: number): string {
		return (!validateEnabled.value || value>0)?"":"error";
	}
		
	
	return  {
		 errorMessage, isError, upgrade, progress, submitOnEnter,
		 sendForm, nextStep, errEmptyStringClass, errEmptyNumberClass
		};
} 
